import React from "react";
import mark from "../../assets/images/brand/talsolution-mark.png";
import "./brand.scss";

/**
 * TalSolution logo: the gradient "S" mark plus wordmark.
 * variant: "light" (dark text, for white backgrounds) | "dark" (white text, for navy backgrounds)
 */
export default function BrandLogo({ variant = "light", size = 34, showText = true, className = "" }) {
  return (
    <span className={`ts-brand ts-brand--${variant} ${className}`}>
      <img src={mark} alt={showText ? "" : "TalSolution"} width={size} height={size} className="ts-brand__mark" />
      {showText && (
        <span className="ts-brand__name">
          Tal<span className="ts-brand__accent">Solution</span>
        </span>
      )}
    </span>
  );
}
